export const getTachoGraphValues = (valueCount: number, minValue: number, eventValues?: number[]): number[] => {
  return eventValues ?? new Array(valueCount).fill(minValue)
}
